//   
// AGNES - Technical Support Web
//   
// TechnicalSupportDetailController.js
//   
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//   
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//   
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//   
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
// 

angular.module("Agnes")
    .controller("TechnicalSupportFormUploadController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "$location", "Upload", "technicalSupportId", "$user", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, $location, Upload, technicalSupportId, user, oidc) {

            $scope.upload = function (file) {
                $activity.start();
                var uploadUrl = "/api/technical-support/form-upload";
                if (technicalSupportId != null) {
                    uploadUrl += "/" + technicalSupportId;
                }
                $scope.uploading = true;
                Upload.upload({
                    url: uploadUrl,
                    method: "POST",
                    data: { file: file },
                    headers: {
                        Authorization: oidc.current.token_type + " " + oidc.current.access_token
                    }
                }).then(function (response) {
                    console.log('First', response);
                    $scope.uploading = false;
                    $location.path("technical-support/detail/" + response.data.id);

                }, function (response) {
                    console.log('Second', response);
                    $notification.addError(response.data, response.response);
                }, function (evt) {
                    //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    $activity.finish();
                });

            }

            $scope.getTechnicalSupportInfo = function (technicalSupportId) {
                if (technicalSupportId !== null) {
                    $activity.start();
                    $http
                        .get("/api/technical-support/" + technicalSupportId, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.technicalSupportInfo = response.data;
                        }, function (response) {
                            $notification.addError(response.status, response);
                        }).then(function () {
                            $activity.finish();
                        });

                }
            }

            $scope.user = user;

            $scope.uploading = false;
            if (technicalSupportId == 0) {
                technicalSupportId = null;
            }
            $scope.technicalSupportId = technicalSupportId;
            $scope.getTechnicalSupportInfo(technicalSupportId);



        }
    ]);